import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { containerConnect } from "@configuratorware/configurator-frontendgui/Framework/ComponentContainer";
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { fetchInitialConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import {
  fetchCategories,
  setSelectedCategoryId,
} from "../../Reducers/Products/Actions";
import Overview from "../../Components/Overview/Overview";
import CustomHeaderContainer from "../CustomHeader/CustomHeaderContainer";

const mapStateToProps = (state) => {
  return {
    Component: Overview,
    categories: state.products.categories,
    selectedCategoryId: state.products.selectedCategoryId,
    HeaderComponent: CustomHeaderContainer,
    isLoggedIn: state.login.isLoggedIn
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadCategories: () => dispatch(fetchCategories()),
  setSelectedCategoryId: (id: number) => dispatch(setSelectedCategoryId(id)),
  loadArticle: async (productIdentifier) => {
    const component = Services.visualization.getComponent();
    if(component){
      Services.store.dispatch({ type: 'RECEIVE_CONFIGURATION', data: { ...Services.store.state.configurator.configuration, item: { ...Services.store.state.configurator.configuration.item, settings: {visualizationCreator: "fallback", visualizationDesigner: "fallback"} }} })
    }
    await Services.configurator.setLoadIdentifier(productIdentifier);
    await Services.store.dispatch(withGlobalLoader(fetchInitialConfiguration()))
  }
 });

export default containerConnect(mapStateToProps, mapDispatchToProps);
